<template>
  <ShowViewForm insite="true" ref="showviewform" v-if="showViewFormData.list && showViewFormData.list.length > 0"
                :data="showViewFormData" :value="temp"
                :soltNameArray='soltNameArray'>
    <el-button type="primary" slot="redirectTo" style="position: absolute; right: 5px; top: -7px; "
               @click="goToListView(temp.redirectTo)">转到列表页面查看
    </el-button>
  </ShowViewForm>
</template>

<script>
import ShowViewForm from '@/components/Formcreated/components/ShowViewForm';
import * as forms from '@/api/forms';

export default {
  name: 'basemessagesview',
  components: { ShowViewForm },
  props: {
    commonObject: {
      type: Object,
      required: true
    },
    commonName: [String]
  },
  data() {
    return {
      temp: {},
      showViewFormData: {
        list: [],
        config: {}
      },
      soltNameArray: ['redirectTo'],
      tableTreeData: [],
      tableColumn: [
        {
          width: 60,
          slots: {
            default: () => {
              return [
                <div style='text-align: center;'>
                  <span class='drag-btn' style='font-size: 16px'>
                    <i class='vxe-icon--menu'></i>
                  </span>
                </div>
              ];
            },
            header: () => {
              return [
                <el-tooltip class='item' effect='dark' content='按住下方九宫格图标可以上下拖动排序！' placement='top'>
                  <i class='vxe-icon--question' onClick={() => {
                    this.showHelpTip2 = !this.showHelpTip2;
                  }}></i>
                </el-tooltip>
              ];
            }
          }
        },
        {
          field: 'cInvCode',
          title: '子件编码',
          treeNode: true,
          minWidth: '260px',
          editRender: { enabled: true },
          slots: {
            edit: (rowObj) => {
              return [
                <auto-new id={rowObj.row.cInvId} name={rowObj.row.cInvCode} idKey='cInvCode' nameKey='cInvName'
                  apiName='inventorys'
                  returnKey={[{ querykey: 'cComUnitName', modelkey: 'cComUnitName' }, {
                    querykey: 'cInvStd',
                    modelkey: 'cInvStd'
                  }]}
                  onChange={(val) => {
                    this.cInvCodeChanged(rowObj.row, val);
                  }}></auto-new>
              ];
            }
          }
        }, {
          field: 'cInvName',
          title: '子件名称',
          minWidth: '240px'
        }, {
          field: 'handleUsers',
          title: '负责人',
          editRender: { enabled: true },
          minWidth: '240px',
          slots: {
            edit: (rowObj) => {
              return [
                <SelectTypeByApi name={rowObj.row.handleUsers} id={rowObj.row.handleUserIds} nameKey='name' idKey='id'
                  apiName='users' multiple={true} onPostdata={(val) => {
                    this.handleUsersChanged(rowObj.row, val);
                  }}></SelectTypeByApi>
              ];
            }
          }
        }, {
          field: 'cInvStd',
          title: '子件规格',
          minWidth: '100px'
        },
        {
          field: 'cComUnitName',
          title: '单位',
          minWidth: '60px'
        }, {
          field: 'baseQtyN',
          title: '基础用量',
          minWidth: '100px',
          editRender: { enabled: true },
          slots: {
            edit: (rowObj) => {
              return [
                <el-input value={rowObj.row.baseQtyN} type='number' onInput={(val) => {
                  this.baseQtyChanged(rowObj.row, val, 'baseQtyN');
                }}></el-input>
              ];
            }
          }
        },
        {
          field: 'baseQtyD',
          title: '基本用量',
          minWidth: '100px',
          editRender: { enabled: true },
          slots: {
            edit: (rowObj) => {
              return [
                <el-input value={rowObj.row.baseQtyD} type='number' onInput={(val) => {
                  this.baseQtyChanged(rowObj.row, val, 'baseQtyD');
                }}></el-input>
              ];
            }
          }
        }, {
          field: 'useQty',
          title: '使用数量',
          minWidth: '100px'
        },
        {
          field: 'refBomName',
          title: '选择BOM',
          minWidth: '200px',
          editRender: { enabled: true },
          slots: {
            edit: (rowObj) => {
              return [
                <auto-new id={rowObj.row.refBomId} disabled={rowObj.row.isNoChooseCInv} name={rowObj.row.refBomName}
                  idKey='id' nameKey='cInvName' apiName='boms' getDataMethod='loadBom'
                  otherQuery={[{ key: 'partId', relation: '=', value: rowObj.row.partId }]}
                  // returnKey={[
                  //   { querykey: 'handleUsers', modelkey: 'handleUsers' },
                  //   { querykey: 'cInvCode', modelkey: 'cInvCode' },
                  //   { querykey: 'cComUnitName', modelkey: 'cComUnitName' },
                  //   { querykey: 'cInvStd', modelkey: 'cInvStd' },
                  //   { querykey: 'cInvName', modelkey: 'cInvName' },
                  //   // { querykey: 'defaultNum', modelkey: 'defaultNum' },
                  //   { querykey: 'partId', modelkey: 'partId' },
                  //   { querykey: 'baseQtyD', modelkey: 'baseQtyD' },
                  //   { querykey: 'baseQtyN', modelkey: 'baseQtyN' },
                  //   { querykey: 'useQty', modelkey: 'useQty' },
                  //   { querykey: 'wipType', modelkey: 'wipType' },
                  //   { querykey: 'procedureId', modelkey: 'procedureId' }
                  // ]}
                  onChange={(val) => {
                    this.refBomIdChanged(rowObj.row, val);
                  }}></auto-new>
              ];
            }
          }
        }, {
          field: 'wipTypeName',
          title: '供应类型',
          editRender: { enabled: true },
          minWidth: '100px',
          slots: {
            edit: (rowObj) => {
              return [
                <el-select value={rowObj.row.wipType} placeholder='请选择' onChange={(val) => {
                  this.wipTypeChanged(rowObj.row, val);
                }}>
                  <el-option key={3} value={3} label='领料'/>
                  <el-option key={4} value={4} label='虚拟'/>
                </el-select>
              ];
            }
          }
        }, {
          field: 'partId',
          title: '物料ID',
          editRender: { enabled: true },
          minWidth: '200px',
          slots: {
            edit: (rowObj) => {
              return [
                <select-type-by-list value={rowObj.row.partId} dataList={rowObj.row.partIdListInternal}
                  placeholder='请先选择母件' onChange={(val) => {
                    rowObj.row.partId = val;
                  }}/>
              ];
            }
          }
        },
        {
          field: 'procedureName',
          title: '所属工序',
          editRender: { enabled: true },
          minWidth: '200px',
          slots: {
            edit: (rowObj) => {
              return [
                <auto-new id={rowObj.row.procedureId} disabled={rowObj.row.procedureNeed}
                  name={rowObj.row.procedureName} idKey='id' nameKey='procedureName' apiName='baseprocedures'
                  onChange={(val) => {
                    rowObj.row.procedureId = val.id;
                    rowObj.row.procedureName = val.name;
                  }}></auto-new>
              ];
            }
          }
        }, {
          title: '操作',
          fixed: 'left',
          minWidth: '170px',
          editRender: { enabled: true },
          slots: {
            default: (rowObj) => {
              return [
                <div style='text-align: center;'>
                  <i onClick={() => this.detailbtnClick(rowObj.row, 'editbomDetail')}
                    class='el-icon-edit frombtn iconStyle  iconStylePrim' title='编辑'></i>
                  <i onClick={() => this.detailbtnClick(rowObj.row, 'addbomDetail')}
                    class='el-icon-circle-plus-outline iconStyle iconStyleError' title='添加下级'></i>
                  <span onClick={() => this.detailbtnClick(rowObj.row, 'delbomDetail')}
                    class='el-icon-delete iconStyle iconStyleDanger' title='删除'></span>
                </div>
              ];
            },
            edit: (rowObj) => {
              return [
                <div style='text-align: center;'>
                  <i onClick={() => this.detailbtnClick(rowObj.row, 'savebomDetail')}
                    class='el-icon-circle-check iconStyle iconStyleInfo' title='保存'></i>
                  <i onClick={() => this.detailbtnClick(rowObj.row, 'cancelbomDetail')}
                    class='el-icon-remove-outline iconStyle iconStyleDanger' title='取消'></i>
                </div>
              ];
            }
          }
        }
      ]
    };
  },
  watch: {
    commonObject: {
      deep: true,
      handler(val) {
        this.$refs.showviewform.reseltActiveName();
        this.InitDate();
      }
    }
  },
  created() {
    this.InitDate();
  },
  methods: {
    InitDate() {
      this.temp = { ...this.temp, ...this.commonObject };
      var queryObj = { SourceCode: 'BaseMessage' };
      forms.getCreeateFrom(queryObj).then(response => {
        this.showViewFormData = response.result.contentData && JSON.parse(response.result.contentData) || {};
      }).catch(() => {
        // console.log(err)
      });
    },
    handleClick(tab, event) {
      // console.log(tab, event)
    },
    goToListView(viewName) {
      this.$router.push('/' + viewName + 's');
    }
  }
};
</script>
<style>
.dialog-mini .el-select {
  width: 100%;
}
</style>
